import { useSelector } from 'react-redux';
import { brandSelector } from '../../redux/reducers/app/params';
import {
  NATIVE_CASINO_PROVIDER_ID,
  NATIVE_CASINO_PROVIDER_ID_BY,
} from '../../constants/appStoreReview';

export const useNativeCasinoProvider = () => {
  const brand = useSelector(brandSelector);

  return brand === 'BY'
    ? NATIVE_CASINO_PROVIDER_ID_BY
    : NATIVE_CASINO_PROVIDER_ID;
};
